import { useAtom } from 'jotai';
import { loadable } from 'jotai/utils';
import { lookupsAtom } from '~/atoms/lookups';
const loadableAtom = loadable(lookupsAtom);
export const useLookups = () => {
    const [lookups] = useAtom(loadableAtom);
    return {
        lookups: lookups.state === 'hasData' ? lookups.data : undefined,
        lookupsLoadingState: lookups.state
    };
};
